import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  sessionExpiredRedirect,
} from '../../redux/actions/app/appActions';

export class SessionTimeoutRedirect extends PureComponent {

  static propTypes = {
    sessionExpiredAnnounced: PropTypes.bool,
    sessionExpiredRedirect: PropTypes.func,
  };

  static defaultProps = {
    sessionExpiredAnnounced: false,
    sessionExpiredRedirect: window.defaultFunc,
  };

  componentDidUpdate(prevProps) {
    const {
      sessionExpiredAnnounced,
      sessionExpiredRedirect,
    } = this.props;

    if (!prevProps.sessionExpiredAnnounced && sessionExpiredAnnounced) {
      sessionExpiredRedirect();
    }
  }

  render() {
    return null;
  }
}

export default connect(state => ({
  sessionExpiredAnnounced: state.app.sessionExpiredAnnounced,
}), {
  sessionExpiredRedirect,
})(SessionTimeoutRedirect);
